import { AvailableLanguages } from '@agro-club/agroclub-shared'
import { SiteSettings } from './types'

export const UsSiteSettings: SiteSettings = {
  DEFAULT_APP_LOCALE: AvailableLanguages.en,
  REACT_APP_CURRENCY_SYMBOL: '$',
  DEFAULT_API_BASE: 'https://api-main-usa.stage.agro.club/api/v1',
  REACT_APP_USE_GOOGLE_MAPS: true,
}
